<template>
  <fields-list
    :fields="fields"
    :editing-data="editingData"
    @update-field="updateField($event.value, $event.field)"
  />
</template>

<script>
import { listsMixin } from "@/mixins/listsMixin";
import { objectManagementMixin } from "@/mixins/objectManagementMixin";
import FieldsList from "@/newComponents/StockManagement/FieldsList.vue";
import { unitConverterMixin } from "@/mixins/management/unitConverterMixin";

export default {
  name: "TobyBoxMaterialFields",

  components: {
    FieldsList,
  },

  mixins: [listsMixin, objectManagementMixin, unitConverterMixin],

  props: {
    /**
     * The specific fields values passed by the parent component
     */
    familySpecificFields: {
      type: Array | Object,
      required: true
    },

    editingData: {
      type: Boolean,
      required: true,
    },
  },

  data() {
    return {
    };
  },

  watch: {
    editingData() {
      this.requiredFieldsFilled();
    }
  },

  computed: {
    fields() {
      return [
        {
          label: this.$i18n.t("Length") + this.getUnitLabel("m"),
          value: this.familySpecificFields.smtb_length,
          varName: 'smtb_length',
          inputType: 'number',
          disabled: false,
          step: '.1',
          min: '0',
        },
        {
          label: this.$i18n.t("Width") + this.getUnitLabel("m"),
          value: this.familySpecificFields.smtb_width,
          varName: 'smtb_width',
          inputType: 'number',
          disabled: false,
          step: '.1',
          min: '0',
        },
        {
          label: this.$i18n.t("Depth") + this.getUnitLabel("m"),
          value: this.familySpecificFields.smtb_depth,
          varName: 'smtb_depth',
          inputType: 'number',
          disabled: false,
          step: '.1',
          min: '0',
        },
      ]
    }
  },

  methods: {
    /**
     * Validations for the various required fields
     *
     * @return {boolean} indicating if the fields are valid
     */
    requiredFieldsValidation() {
      return true;
    },
  }
};
</script>



// WEBPACK FOOTER //
// src/newComponents/StockManagement/SpecificMaterialSections/MaterialFieldsTobyBox.vue